export const constants = {
  LIVE_PIANO_AUTOSTART: "@settings/livePianoAutostart",
  LIVE_PIANO_ANNOUNCEMENT: "@settings/livePianoAnnouncement",
};
